import { Wrench, Gear, ShoppingCart, ArrowRight } from "@phosphor-icons/react";

const Services = () => {
  const services = [
    {
      icon: Wrench,
      title: "Laser Repair",
      description:
        "Expert diagnosis and field repair for Sciton and Cutera systems. We offer OEM-grade quality and precision at a better value than the original manufacturers.",
      features: ["All Major Brands", "Component-Level Repair", "Calibration"],
      image: "https://customer-assets.emergentagent.com/wingman/9c19584c-47ce-4fca-a14b-ad011323fd33/attachments/71c981c3ca97455ebbde6f33f6cd170e_images-1.jpg",
      span: "md:col-span-7",
      featured: true,
    },
    {
      icon: Gear,
      title: "Preventive Maintenance",
      description:
        "Ensure optimum performance and extend equipment life with our comprehensive service agreements and scheduled performance testing.",
      features: ["Scheduled Service", "Performance Testing", "Documentation"],
      image: "https://customer-assets.emergentagent.com/wingman/9c19584c-47ce-4fca-a14b-ad011323fd33/attachments/82d59c33b0ae4d52942b7d714d249a5f_images-2.jpg",
      span: "md:col-span-5",
      featured: false,
    },
    {
      icon: ShoppingCart,
      title: "Equipment Sales",
      description:
        "Certified refurbished Sciton and Cutera systems. Guaranteed quality and performance that restores your unit to showroom-floor standards at a fraction of the cost.",
      features: ["Certified Units", "Full Warranty", "Training Support"],
      image: "https://customer-assets.emergentagent.com/wingman/9c19584c-47ce-4fca-a14b-ad011323fd33/attachments/82d59c33b0ae4d52942b7d714d249a5f_images-2.jpg",
      span: "md:col-span-5",
      featured: false,
    },
  ];

  const scrollToContact = () => {
    const element = document.querySelector("#contact");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="services"
      className="py-24 sm:py-32 bg-slate-50"
      data-testid="services-section"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        {/* Section Header */}
        <div className="mb-16">
          <span className="text-xs tracking-[0.2em] uppercase font-bold text-[#0B2F6B]">
            What We Do
          </span>
          <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl tracking-tight font-bold text-[#1A1A2E]">
            Aesthetic Laser Equipment Services
          </h2>
          <p className="mt-4 text-lg text-slate-600 max-w-2xl">
            From emergency repairs to preventive maintenance, we keep your practice running smoothly.
          </p>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          {services.map((service, index) => (
            <div
              key={service.title}
              className={`bento-card ${service.span} bg-white border border-slate-200 overflow-hidden group`}
              data-testid={`service-card-${index}`}
            >
              {/* Image */}
              <div className="relative h-48 sm:h-56 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent" />
                <div className="absolute bottom-4 left-4">
                  <service.icon className="w-10 h-10 text-white" weight="duotone" />
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-xl sm:text-2xl tracking-tight font-semibold text-[#1A1A2E]">
                  {service.title}
                </h3>
                <p className="mt-3 text-slate-600 leading-relaxed">
                  {service.description}
                </p>

                {/* Features */}
                <div className="mt-4 flex flex-wrap gap-2">
                  {service.features.map((feature) => (
                    <span
                      key={feature}
                      className="px-3 py-1 text-xs font-semibold bg-slate-100 text-slate-700"
                    >
                      {feature}
                    </span>
                  ))}
                </div>

                {/* CTA */}
                <button
                  onClick={scrollToContact}
                  className="mt-6 inline-flex items-center text-sm font-semibold text-[#0B2F6B] hover:text-[#0d3d8a] transition-colors group/btn"
                >
                  Learn More
                  <ArrowRight className="w-4 h-4 ml-2 transition-transform group-hover/btn:translate-x-1" />
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Brands We Service */}
        <div className="mt-20 text-center">
          <span className="text-xs tracking-[0.2em] uppercase font-bold text-slate-500">
            Brands We Service
          </span>
          <div className="mt-8 flex flex-wrap justify-center gap-x-12 gap-y-6 text-xl font-bold text-slate-300">
            {["Cutera", "Candela", "Alma", "Palomar", "Lumenis", "Sciton"].map(
              (brand) => (
                <span
                  key={brand}
                  className="hover:text-slate-900 transition-colors cursor-default"
                >
                  {brand}
                </span>
              )
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
